import { calculateAspectRatio } from "@msuite/utils/files";
import { FileIcon } from "../../file-upload";
import { Tooltip } from "../../tooltip";
import { cn } from "../../utils";
import type { LightboxItem } from "./shared";

/** Props Interface */
interface LightboxScrollerItemProps {
	item: LightboxItem;
	currentItemId: string;
	onClick: (itemId: string) => void;
}

export function LightboxScrollerItem({ item, onClick, currentItemId }: LightboxScrollerItemProps) {
	/** Computed */
	const isImage = item.contentType.startsWith("image/");

	/** Render */
	return (
		<Tooltip label={item.fileName}>
			<div
				className={cn(
					"h-[50px] card rounded-none cursor-pointer border-0",
					item.itemId === currentItemId && "ring ring-accent-500/50",
					"flex-center",
				)}
				key={item.src}
				style={{
					aspectRatio: calculateAspectRatio(item.width, item.height) || "1 / 1",
					backgroundImage: `url(${item.src})`,
					backgroundSize: "cover",
				}}
				onClick={(e) => {
					e.stopPropagation();
					onClick(item.itemId);
				}}
			>
				{!isImage && <FileIcon fileType={item.contentType} />}
			</div>
		</Tooltip>
	);
}
